<rma-split-marketing-layout *transloco="let t; read: 'searchprofile'">
  <ng-container content>
    @if (profileCreationSuccess()) {
      <header class="my-6 justify-center">
        <h2 class="text-heading-2 my-6">{{ t('thanks') }}</h2>
        <p class="text-steel-80 w-full text-base font-normal">{{ t('team-will-be-in-touch') }}</p>
      </header>
      <a routerLink="/" queryParamsHandling="preserve" mat-flat-button color="primary">{{ t('back-to-ratemyagent') }}</a>
    } @else {
      <button class="p-0" type="button" mat-icon-button color="primary" rmaBackButton>
        <rma-icon glyph="arrow_back" />
      </button>
      <header class="my-6 flex flex-col gap-3">
        <h2 class="text-heading-2">{{ t('profile-creation') }}</h2>
        <p class="text-steel-80 w-full text-base font-normal">{{ t('enter-details') }}</p>
      </header>
      <form class="rmaForm" [formGroup]="profileForm.form" (ngSubmit)="profileForm.validateAndSubmit()">
        @if (formOptions$ | async; as formOptions) {
          @if (showCallout$ | async) {
            <rma-callout class="mb-4" [message]="t('callout')" calloutType="info" />
          }

          @if (formOptions.countries.length) {
            <mat-form-field density="compact">
              <mat-label>{{ 'form.label.country' | transloco }}</mat-label>
              <mat-select formControlName="country">
                @for (country of formOptions.countries; track country.value) {
                  <mat-option [value]="country.value">
                    {{ t('options.' + country.label) }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          @if (formOptions.industries.length) {
            <mat-form-field>
              <mat-label>{{ 'form.label.industry' | transloco }} </mat-label>
              <mat-select formControlName="industry">
                @for (industry of formOptions.industries; track industry.value) {
                  <mat-option [value]="industry.value">
                    {{ t('options.' + industry.label) }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          @if (formOptions.roles.length && profileForm.controls.industry.value === 'Real Estate') {
            <mat-form-field>
              <mat-label>{{ 'form.label.role' | transloco }} </mat-label>
              <mat-select formControlName="role">
                @for (role of formOptions.roles; track role.value) {
                  <mat-option [value]="role.value">
                    {{ t('options.' + role.label) }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        }
        <mat-form-field>
          <mat-label>{{ 'form.label.first-name' | transloco }} </mat-label>
          <input matInput type="text" autocomplete="given-name" formControlName="firstName" autofocus  />
          <mat-error />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'form.label.last-name' | transloco }} </mat-label>
          <input matInput type="text" autocomplete="family-name" formControlName="lastName" />
          <mat-error />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'form.label.email' | transloco }} </mat-label>
          <input matInput type="text" autocomplete="email" formControlName="email" />
          <mat-error />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'form.label.phone' | transloco }} </mat-label>
          <input matInput type="text" autocomplete="tel" formControlName="phone" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'form.label.agency-name' | transloco }} </mat-label>
          <input matInput type="text" autocomplete="organization" formControlName="agencyName" />
        </mat-form-field>
        <mat-form-field *rmaIfFeatureFlag="mandatoryLicenseFlag">
          <mat-label>{{ 'form.label.nar-number' | transloco }} </mat-label>
          <input matInput type="text" formControlName="narNumber" />
        </mat-form-field>

        <button type="button" mat-flat-button color="primary" type="submit" [rmaLoadingIndicator]="profileForm.submitting$ | async">
          {{ 'action.submit' | transloco }}
        </button>
      </form>
    }
  </ng-container>

  <ng-container marketing>
    <img class="m-auto max-h-[60vh]" [src]="'/profile-search/desktop-hero-verify-dashboard-v2.png' | staticImageUrl" alt="" />
    <div class="t wordbreak-normal text-center text-2xl font-medium text-white xl:text-4xl">
      {{ t('everything-you-need') }}
    </div>
  </ng-container>
</rma-split-marketing-layout>
